import React, { useState, useEffect, useRef } from 'react';
import pen from "../../../../assets/images/pen.png";

// import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import ApexCharts from 'react-apexcharts';
// import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { Badge, Modal, Dropdown, Row, Col, Button, Form, Stack, Tabs, Tab } from 'react-bootstrap';

import { faPlus, faXmark, faCircle, faPaperclip, faPencil, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';

import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import edit from "../../../../assets/images/edit.png";
import Export from "../../../../assets/images/export.svg";
import EmailGreen from "../../../../assets/images/recover_email.png";
import EmailRed from "../../../../assets/images/pending_email.png";
import { GETCONDITIONCODE, GETDESTINATION, GETOWNERCODE, GETULDDETAILS, MVTHDETAILS, ULDSETRECOVERY, UPDATERECOVERY } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios.js';
import { toast } from 'react-toastify';
import RecoveryDetails from './RecoveryDetails.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

function MVTMismatch() {
    const isMounted = useRef(false);
    const [activeTab, setActiveTab] = useState('All');
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [totalRows, setTotalRows] = useState([]);
    const [totalRowsC, setTotalRowsC] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [emailData, setEmailData] = useState();
    const [foundData, setFoundData] = useState({});
    const [changeData, setChangeData] = useState({});

    const [resolveData, setResolveData] = useState({});

    const [showModal, setShowModal] = useState(false);
    const [missingModal, setMissingModal] = useState(false);
    const handleModalClose = () => { setShowModal(false); };
    const [isSaving, setIsSaving] = useState(false);

    const [gridData, setGridData] = useState({
        Active: [],
        Closed: []

    });

    const [formData, setFormData] = useState({});
    const [updatedData, setUpdatedData] = useState({});
    const [getOwnerCode, setGetOwnerCode] = useState([]);
    const [getCondCode, setGetCondCode] = useState([]);
    const [getDestination, setGetDestination] = useState([]);

    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);

    const [transferredBy, setTransferredBy] = useState([]);
    const [selectedTransferredBy, setSelectedTransferredBy] = useState(null);
    const [receivedBy, setReceivedBy] = useState([]);
    const [selectedReceivedBy, setSelectedReceivedBy] = useState(null);

    const [modalData, setModalData] = useState({});
    const [statusData, setStatusData] = useState(modalData.nestedData || []);
    const [isModal, setIsModal] = useState(false);

    const gridRefs = {
        All: useRef(null),
        UCM: useRef(null),
        SCM: useRef(null),
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);

        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'All') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ All: {} });
            }, 1);
        } else if(tab == 'UCM Out') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ UCM: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ SCM: {} });
            }, 1);
        }
    };

    const fetchOwnerCode = async () => {
        try {

            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCondCode = async () => {
        try {

            const res = await withRFSToken.post(GETCONDITIONCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setGetCondCode(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const getCondCodes = [
        { label: 'Serviceable', value: 'SER' },
        { label: 'Damaged', value: 'DAM' },
        { label: 'Discarded', value: 'DIS' },
    ];
    const getStatus = [
        { label: 'In Operation', value: 1 },
        { label: 'On Air', value: 4 },
        { label: 'On Loan', value: 5 },
        { label: 'Repair', value: 2 },
        { label: 'In Reserve', value: 3 },
        // { label: 'Missing', value: 17 },
    ];

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    // ++++++++++++++ Status Overview.

    const [statusSeries, setStatusSeries] = useState([
        {
            name: 'ULD Status',
            data: []
        },
    ]);

    const maxValue = Math.max(...statusSeries[0].data) + 10;

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab].current) {
            // let token = "Bearer " + localStorage.ULD;
            jqxCookieCall()
            let tabType = '';
            if (activeTab == 'All') { tabType = 'All' } else if (activeTab == 'UCM') { tabType = 'UCM Out' } else { tabType = 'SCM' }
            const source = {
                datatype: "json",
                id: "",
                datafields: [
                    { name: "id", type: "string" },
                    { name: "uld_number", type: "string" },
                    { name: "review", type: "string" },
                    { name: "message_type", type: "date" },
                    { name: "mismatch_type", type: "string" },
                    { name: "system_location", type: "string" },
                    { name: "message_location", type: "date" },
                    { name: "createdat", type: "string" },
                    { name: "mvt_missing_id", type: "string" },
                ],
                url: `${process.env.REACT_APP_RFS_URL}mvt-mismatch-list?tab_name=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader("Authorization", token);
                // },
                pagesize: 20,
                filter: function (allfilters) {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);

            const columns = [
                { text: "ULD Number", filtertype: "textbox", datafield: "uld_number", width: "12%" },
                {
                    text: "Review", filtertype: "none", datafield: "review", width: "6%",
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        return '<div class="set_review"> <img src="' + pen + '" class="row_edit" /> Review </div>';
                    },
                },
                { text: "Message Type", filtertype: "textbox", datafield: "message_type", width: "12%" },
                { text: "Mismatch Type", filtertype: "textbox", datafield: "mismatch_type", width: "12%" },
                { text: "System Location", filtertype: "textbox", datafield: "system_location", width: "12%" },
                { text: "Message Location", filtertype: "textbox", datafield: "message_location", width: "12%" },
                { text: "Timestamp", filtertype: "textbox", datafield: "createdat", width: "12%" },
            ];

            const gridOptions = {
                width: "100%",
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ["50", "100", "200", "500"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                rowdetails: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);

            // Styling Enhancements
            window.$(gridRefs[activeTab].current).find(".jqx-grid-column-header").css("background-color", "white");
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on("mouseover", () => {
                    window.$(row).addClass("row-hover");
                });
                window.$(row).on("mouseout", () => {
                    window.$(row).removeClass("row-hover");
                });
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex === 2) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    // setSelectedRowData(args)
                    loadReview(args.mvt_missing_id);
                }
            });
            // window.$(gridRef.current).on('click', '.set_review', function () {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            //     // setIsModal(true);
            //     // const rId = rowData.uid
            //     // const nestedData = dataAdapter.loadedData.Rows[rId].awb;
            //     // // console.log("🚀 ~ nd:", nd)
            //     // const transformData = { ...rowData, nestedData }
            //     // setModalData(transformData);
            //     // setStatusData(nestedData);
            //     const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

            //     if (boundIndex !== undefined) {
            //         const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
            //         const pageIndex = pagingInfo.pagenum;
            //         const pageSize = pagingInfo.pagesize;
            //         const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
            //         // console.log('Global Index:', globalIndex); 
            //         const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
            //         if (rowData) {
            //             console.log('Row Data:', rowData);
            //             loadReview(rowData.mvt_missing_id)

            //             // handleProcessButtonClick(rowData.movement_type, rowData.message_data, rowData.email_inbox_id);
            //         } else {
            //             console.error('No data found for the given row index.');
            //         }
            //     } else {
            //         console.error('Bound index could not be retrieved. Check the row index and data binding.');
            //     }
            // });
        }
    }, [gridData]);


    const loadDetails = async (uldNumber, missingId, forFound) => {
        try {
            const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber, missing_id: missingId })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (forFound) {
                        setFoundData(innerData);
                        setChangeData(innerData);
                        setMissingModal(true);
                        setFormData(innerData.movement_history[0]);
                        fetchOwnerCode();
                        fetchCondCode();
                        fetchDestination();
                    } else {
                        setSelectedRowData(innerData);
                    }

                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const loadReview = async (id) => {
        try {
            const res = await withRFSToken.post('mvt-mismatch-details', { mvt_missing_id: id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setFoundData(innerData);
                    setChangeData(innerData);
                    setFormData(innerData?.trucking_info?.movement_history[0]);
                    setIsModal(true);
                    fetchOwnerCode();
                    fetchCondCode();
                    fetchDestination();
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (formData?.origin) {
            const selectedOrigin = getDestination.find(option => option.value === formData?.origin);
            const selectedOriginHandler = selectedOrigin?.address?.find(option => option.id === formData?.origin_handler_id);
            if (selectedOrigin) {
                setOriginHandler(selectedOrigin.address);
                setSelectedOriginId(selectedOrigin.station_id);
                setSelectedOriginHandler({ label: selectedOriginHandler?.company_name, value: selectedOriginHandler?.id });
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setOriginHandler([]);
                setSelectedOriginId(null);
                setSelectedOriginHandler(null);
            }
        } else {
            setOriginHandler([]);
            setSelectedOriginId(null);
            setSelectedOriginHandler(null);
        }
        if (formData?.destination) {
            const selectedDestination = getDestination.find(option => option.value === formData.destination);
            const selectedDestinationHandler = selectedDestination?.address?.find(option => option.id === formData?.destination_handler_id);
            if (selectedDestination) {
                setDestinationHandler(selectedDestination.address);
                setSelectedDestinationId(selectedDestination.station_id);
                setSelectedDestinationHandler({ label: selectedDestinationHandler?.company_name, value: selectedDestinationHandler?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setDestinationHandler([]);
                setSelectedDestinationId(null);
                setSelectedDestinationHandler(null);
            }
        } else {
            setDestinationHandler([]);
            setSelectedDestinationId(null);
            setSelectedDestinationHandler(null);
        }
        if (formData?.transfer_point) {
            const selectedTransferPoint = getDestination.find(option => option.value === formData.transfer_point);
            const selectedTransferBy = selectedTransferPoint?.address?.find(option => option.id === formData?.transferred_by_id);
            if (selectedTransferPoint) {
                setTransferredBy(selectedTransferPoint.address);
                setSelectedTransferredBy({ label: selectedTransferBy?.company_name, value: selectedTransferBy?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setTransferredBy([]);
                setSelectedTransferredBy(null);
            }
        } else {
            setTransferredBy([]);
            setSelectedTransferredBy(null);
        }
        if (formData?.luc_final_dest) {
            const selectedFinalDest = getDestination.find(option => option.value === formData.luc_final_dest);
            console.log("🚀 ~ useEffect ~ selectedFinalDest:", selectedFinalDest)
            const selectedReceivedBy = selectedFinalDest?.address?.find(option => option.id === formData?.received_by_id);
            if (selectedFinalDest) {
                setReceivedBy(selectedFinalDest.address);
                setSelectedReceivedBy({ label: selectedReceivedBy?.company_name, value: selectedReceivedBy?.id } || null);
            } else {
                // Reset or handle if the origin value doesn't match any destination
                setReceivedBy([]);
                setSelectedReceivedBy(null);
            }
        } else {
            setReceivedBy([]);
            setSelectedReceivedBy(null);
        }
    }, [formData, getDestination])

    const handleDropdownItemClick = (pos, action) => {
        const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
        keysToRemove.forEach(key => localStorage.removeItem(key));



        // const missingUld = async (uld) => {
        //     setMissingModal(true);
        //     setMissingInfo(uld);
        // }


        // Logic for handling 'top' position
        const handleTopAction = () => {

            if (gridSelect.length === 0) {
                toast.error('Please select at least one stock to Operate');

            } else {
                if (action === 'ULD Found') {
                    if (gridSelect.length > 1) {
                        toast.error('You Can process only one ULD at a time')
                    } else {
                        if (gridSelect[0].status == 'Missing') {
                            toast.error('ULD is already Missing')
                        } else {
                            // missingUld(gridSelect[0].uld_number);
                            loadDetails(gridSelect[0].uld_number, gridSelect[0].missing_id, 'found');
                        }
                    }
                } else {
                }
            }
        };

        // Main conditional logic based on the position (pos)
        if (pos === 'details') {
            // handleDetailsAction();
        } else if (pos === 'top') {
            handleTopAction();
        }
    };

    const missingModalClose = () => {
        setMissingModal(false);
        setIsEdit(false);
        setFormData({});
    }

    const handleReviewChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        if (name === 'action_type') {
            if (value === 'M') {
                setChangeData(prevFormData => ({
                    ...prevFormData,
                    trucking_info: {
                        ...prevFormData.trucking_info,
                        status: "Missing"
                    }
                }));
            } else {
                setChangeData(prevFormData => ({
                    ...prevFormData,
                    trucking_info: {
                        ...prevFormData.trucking_info,
                        status: foundData.trucking_info.status
                    }
                }));
            }

        }
    }


    const handleCloseClick = () => {
        setSelectedRowData(null);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const [recEmailData, setRecEmailData] = useState({ rec_email: '' });
    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        setRecEmailData(prevState => ({
            ...prevState,
            [name]: value // Dynamically update the field based on the input name
        }));
    };



    const [isedit, setIsEdit] = useState(false);
    const handleEditMode = () => {
        setIsEdit(true);
        // setFormData(changeData.trucking_info);
        setFormData(prevFormData => ({
            ...prevFormData,
            ...changeData.trucking_info
        }));
    }
    const handleEditModeBack = () => {
        setIsEdit(false);
        setFoundData(changeData);
        // setFormData(changeData.trucking_info);
        setFormData(prevFormData => ({
            ...prevFormData,
            ...changeData.trucking_info
        }));
    }
    const handleFoundChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    }
    const closeModal = () => {
        setIsModal(false);
        setIsEdit(false);
    };

    const updateReview = async () => {
        setIsSaving(true);
        // let sendData = {};
        // if (isedit) {
        // console.log('foundData',foundData);
        const sendData = {
            ...formData,
            mvt_missing_id: foundData.mvt_missing_id,
            status: foundData.last_uld_status_id,
            condition_code: foundData.condition_code,
            flight_number: `${formData.flight_code}-${formData.flight_num}`,
        };
        // } else {
        //     sendData = {
        //         ...formData,
        //         missing_id: foundData.missing_details.missing_id,
        //         status: foundData.last_uld_status_id,
        //         condition_code: foundData.condition_code,
        //         flight_number: `${formData.flight_code}-${formData.flight_num}`,
        //     };
        // }
        // console.log('sendData',sendData);

        try {
            const res = await withRFSToken.post('mvt-mismatch-edit', sendData)
            // .then(function (res) {
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                window.$(gridRefs[activeTab]).jqxGrid('updatebounddata');
                // setGridData({ Active: {} });
                // setIsLoading(true);
                setIsSaving(false);
                closeModal();
                window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                // setGridSelect([]);
            } else { toast.error(res.data.response_msg); setIsSaving(false); }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    return (
        <>
            {console.log('formData', formData)}
            {console.log('foundData', foundData)}
            <div className='lcontent'>
                <div className="mb-3 nestedtabs rounded minh">
                    <div className='d-flex'>
                        {/* <Dropdown>
                            <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handleDropdownItemClick('top', 'ULD Found')}>Select</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <span className="selected">
                            Selected ULD <Badge>{gridSelect.length}</Badge>
                        </span> */}
                    </div>
                </div>

                {/* <div className='ulddown'>
                    {activeTab == 'Active' ? (
                        <>
                            <button ><img src={Export} /> Download</button>
                        </>
                    ) : (
                        <>
                            <button ><img src={Export} /> Download</button>
                        </>
                    )
                    }
                </div> */}

                <div className="maindiv">
                    <div className='trashdonload'>
                        <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="booking_tab">
                            <Tab eventKey="All" title={<span>All</span>} className='moveto'>
                                {!isLoading && <div ref={gridRefs.All} className='bookinggrid' ></div>}
                            </Tab>
                            <Tab eventKey="UCM" title={<span>UCM</span>} className='moveto'>
                                {!isLoading && <div ref={gridRefs.UCM} className='bookinggrid' ></div>}
                            </Tab>

                            <Tab eventKey="SCM" title={<span>SCM</span>} className='moveto'>
                                {!isLoading && <div ref={gridRefs.SCM} className='bookinggrid' ></div>}
                            </Tab>
                        </Tabs>
                        {!isLoading && (
                            <>
                                {/* <div ref={gridRef} className="bookinggrid"></div> */}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                        <h3>{emailData?.last_seen_loc}</h3>
                        <Form.Label>Recovery Email Address</Form.Label>
                        <Form.Control name='rec_email' placeholder='Recovery Email Address' onChange={handleEmailChange} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className=' w-50 mx-auto are_bottom'>
                        <Button variant="primary">
                            Submit
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={isModal} onHide={closeModal} className="addfrom change_type" centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Review Order</Modal.Title>
                    <p className='p_formal text-start'>Please review the information below and update accordingly.</p>
                </Modal.Header>
                <Modal.Body>
                    {/* <h3>ULD Found - {foundData.uld_number}</h3>
                    <p>Please review the information below and select the <br /> Report ULD Found button to report the ULD as found. </p> */}
                    <Row>
                        <Col sm='6'>
                            <div className='missing_info mb-3'>

                                <h4 className='position-relative'>Review Mismatch</h4>
                                <p>Choose how to handle the ULD mismatch</p>
                                <Form.Group className='sl_status'>
                                    <Form.Check
                                        label="Reviewed"
                                        name="action_type"
                                        type='radio'
                                        id='R'
                                        value='R'
                                        checked={formData?.action_type === 'R'}
                                        onChange={handleReviewChange}
                                    />
                                    <Form.Check
                                        label="Missing"
                                        name="action_type"
                                        type='radio'
                                        id='M'
                                        value='M'
                                        checked={formData?.action_type === 'M'}
                                        onChange={handleReviewChange}
                                    />
                                </Form.Group>
                            </div>
                            <div className='missing_info mb-0'>

                                <h4 className='position-relative'>ULD Status
                                    <Link className='raedit' to='#' onClick={isedit ? handleEditModeBack : handleEditMode}>{isedit ? '' : <FontAwesomeIcon icon={faPencil} />} {isedit ? 'Back' : 'Edit'}</Link></h4>
                                <p>The status of the ULD will be changed to the following</p>

                                <ul className='rauld_found'>
                                    <li><span>Status</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit && formData.action_type !== 'M' ?
                                                <Select
                                                    options={getStatus}
                                                    onChange={(selected) => {
                                                        const updatedData = { ...foundData, uld_status_id: selected.value, status: selected.label };
                                                        setFoundData(updatedData);
                                                        setUpdatedData({ ...updatedData, uld_status_id: selected.value });
                                                    }}
                                                    placeholder="Status"
                                                    className='autoslct'
                                                    name="status"
                                                    value={getStatus.find(option => option.value == foundData.trucking_info?.uld_status_id) || ''}
                                                />
                                                :
                                                <>{changeData?.trucking_info?.status || ''}</>
                                            }
                                        </span></li>
                                    <li><span>Condition</span>
                                        <span className='d-flex'>
                                            <label>:</label>
                                            {isedit ?
                                                <Select
                                                    options={getCondCodes}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        const updatedData = { ...foundData, condition_code: selected.value };
                                                        setFoundData(updatedData);
                                                        setUpdatedData({ ...updatedData, condition_code: selected.value });
                                                    }}
                                                    placeholder="Condition Code"
                                                    className='autoslct'
                                                    name="condition_code"
                                                    value={getCondCodes.find(option => option.value === foundData.trucking_info?.condition_code) || ''}
                                                />
                                                :
                                                <>{changeData.trucking_info?.condition_code === 'SER' ? 'Serviceable' : changeData.trucking_info?.condition_code === 'DAM' ? 'Damage' : changeData.trucking_info?.condition_code === 'DIS' ? 'Discarded' : ''}</>
                                            }
                                        </span></li>
                                </ul>
                                <hr />
                                <ul className='rauld_found'>
                                    {['In Operation', 'On Air', 'In Reserve'].includes(foundData.trucking_info?.status) ?
                                        <>
                                            {/* {console.log('foundData', foundData?.movement_history[0]?.flight_number)} */}
                                            <li>
                                                <span>Flight Number </span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Select
                                                                options={getOwnerCode}
                                                                onChange={(selected) => {
                                                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                    const updatedData = { ...formData, flight_code: selected.value };
                                                                    setFormData(updatedData);
                                                                    // setUpdatedData({ ...updatedData, origin: selected.value });
                                                                }}
                                                                placeholder="Code"
                                                                className='autoslct'
                                                                name="flight_code"
                                                                value={getOwnerCode.find(option => option.value === formData?.flight_code)}
                                                            /> -
                                                            <Form.Control
                                                                type="text"
                                                                placeholder=""
                                                                name='flight_num'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.flight_num || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.flight_number}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Flight Date </span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name='flight_date'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.flight_date || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.flight_date}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Origin </span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='origin'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.origin || ''}
                                                    /> */}
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(selected) => {
                                                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                    const updatedData = { ...formData, origin: selected.value, handler_name: '' };
                                                                    setFormData(updatedData);
                                                                    setOriginHandler(selectedDestination ? selectedDestination.address : []);
                                                                    setSelectedOriginId(selectedDestination.station_id);
                                                                    setSelectedOriginHandler(null);
                                                                    setUpdatedData({ ...updatedData, origin: selected.value });
                                                                }}
                                                                placeholder="Origin"
                                                                className='autoslct'
                                                                name="origin"
                                                                value={getDestination.find(option => option.value === formData?.origin)}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.origin}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Origin Handler Name</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>

                                                            <Select
                                                                options={originHandler.map(handler => ({
                                                                    value: handler.id,
                                                                    label: handler.company_name
                                                                }))}
                                                                onChange={(selected) => {
                                                                    const updatedData = { ...formData, origin_handler_id: selected.value, origin_handler: selected.label };
                                                                    setFormData(updatedData);
                                                                    setSelectedOriginHandler(selected);
                                                                    setUpdatedData(updatedData);
                                                                }}
                                                                placeholder="Handler Name"
                                                                className='autoslct'
                                                                name="origin_handler"
                                                                // value={originHandler.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                                value={selectedOriginHandler ? { value: selectedOriginHandler.value, label: selectedOriginHandler.label } : null}
                                                                isDisabled={!originHandler.length}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.origin_handler}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Destination</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='destination'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.destination || ''}
                                                    /> */}
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(selected) => {
                                                                    const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                    const updatedData = { ...formData, destination: selected.value, handler_name: '' };
                                                                    setFormData(updatedData);
                                                                    setDestinationHandler(selectedDestination ? selectedDestination.address : []);
                                                                    setSelectedDestinationId(selectedDestination.station_id);
                                                                    setSelectedDestinationHandler(null);
                                                                    setUpdatedData({ ...updatedData, destination: selected.value });
                                                                }}
                                                                placeholder="Destination"
                                                                className='autoslct'
                                                                name="destination"
                                                                value={getDestination.find(option => option.value === formData?.destination)}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.destination}</>
                                                    }
                                                </span>
                                            </li>
                                            <li>
                                                <span>Destination Handler Name</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            {/* <Form.Control
                                                        type="text"
                                                        placeholder=""
                                                        name='destination_handler'
                                                        maxLength={9}
                                                        // onChange={handleInputChange}
                                                        value={foundData?.movement_history[0]?.destination_handler || ''}
                                                    /> */}
                                                            <Select
                                                                options={destinationHandler.map(handler => ({
                                                                    value: handler.id,
                                                                    label: handler.company_name
                                                                }))}
                                                                onChange={(selected) => {
                                                                    const updatedData = { ...formData, destination_handler_id: selected.value, destination_handler: selected.label };
                                                                    setFormData(updatedData);
                                                                    setSelectedDestinationHandler(selected);
                                                                    setUpdatedData(updatedData);
                                                                }}
                                                                placeholder="Handler Name"
                                                                className='autoslct'
                                                                name="destination_handler"
                                                                // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                                                                value={selectedDestinationHandler ? { value: selectedDestinationHandler.value, label: selectedDestinationHandler.label } : null}
                                                                isDisabled={!destinationHandler.length}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.destination_handler}</>
                                                    }
                                                </span>
                                            </li>
                                            <li><span>Registration Number</span>
                                                <span className='d-flex'>
                                                    <label>:</label>
                                                    {isedit ?
                                                        <>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder=""
                                                                name='flight_reg_number'
                                                                maxLength={9}
                                                                onChange={handleFoundChange}
                                                                value={formData?.flight_reg_number || ''}
                                                            />
                                                        </>
                                                        : <>{foundData?.trucking_info?.movement_history[0]?.flight_reg_number}</>
                                                    }
                                                </span>
                                            </li>
                                        </>
                                        : (foundData.trucking_info?.status === 'On Loan' ?
                                            <>
                                                <li>
                                                    <span>Transfer Date</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder=""
                                                                    name='operation_date'
                                                                    maxLength={9}
                                                                    onChange={handleFoundChange}
                                                                    value={formData?.operation_date || ''}
                                                                />
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.operation_date}</>
                                                        }
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Control Receipt Number</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder=""
                                                                    name='control_receipt_no'
                                                                    maxLength={9}
                                                                    onChange={handleFoundChange}
                                                                    value={formData?.control_receipt_no || ''}
                                                                />
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.control_receipt_no}</>
                                                        }
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Transfer Point</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Select
                                                                    options={getDestination}
                                                                    onChange={(selected) => {
                                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                        const updatedData = { ...formData, transfer_point: selected.value, };
                                                                        setFormData(updatedData);
                                                                        setTransferredBy(selectedDestination ? selectedDestination.address : []);
                                                                        setSelectedTransferredBy(null);
                                                                        setUpdatedData({ ...updatedData, luc_final_dest: selected.value });
                                                                    }}
                                                                    placeholder="TransferPoint"
                                                                    className='autoslct'
                                                                    name="transfer_point"
                                                                    value={getDestination.find(option => option.value === formData?.transfer_point)}
                                                                />
                                                                {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='transfer_point'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.transfer_point || ''}
                                                        /> */}
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.transfer_point}</>
                                                        }
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Transferred By</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Select
                                                                    options={transferredBy.map(handler => ({
                                                                        value: handler.id,
                                                                        label: handler.company_name
                                                                    }))}
                                                                    onChange={(selected) => {
                                                                        const updatedData = { ...formData, transferred_by_id: selected.value, transferred_by: selected.label };
                                                                        setFormData(updatedData);
                                                                        setSelectedTransferredBy(selected);
                                                                        setUpdatedData(updatedData);
                                                                    }}
                                                                    placeholder="Transferred By"
                                                                    className='autoslct'
                                                                    name="transferred_by"
                                                                    // value={transferredBy.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                                    value={selectedTransferredBy ? { value: selectedTransferredBy.value, label: selectedTransferredBy.label } : null}
                                                                    isDisabled={!transferredBy.length}
                                                                />
                                                                {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='transferred_by'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.transferred_by || ''}
                                                        /> */}
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.transferred_by}</>
                                                        }
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Final Destination</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Select
                                                                    options={getDestination}
                                                                    onChange={(selected) => {
                                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                        const updatedData = { ...formData, luc_final_dest: selected.value, };
                                                                        setFormData(updatedData);
                                                                        setReceivedBy(selectedDestination ? selectedDestination.address : []);
                                                                        setSelectedReceivedBy(null);
                                                                        setUpdatedData({ ...updatedData, luc_final_dest: selected.value });
                                                                    }}
                                                                    placeholder="Final Destination"
                                                                    className='autoslct'
                                                                    name="luc_final_dest"
                                                                    value={getDestination.find(option => option.value === formData?.luc_final_dest) || ''}
                                                                />
                                                                {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='luc_final_dest'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.luc_final_dest || ''}
                                                        /> */}
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.luc_final_dest}</>
                                                        }
                                                    </span>
                                                </li>
                                                <li>
                                                    <span>Received By</span>
                                                    <span className='d-flex'>
                                                        <label>:</label>
                                                        {isedit ?
                                                            <>
                                                                <Select
                                                                    options={receivedBy.map(handler => ({
                                                                        value: handler.id,
                                                                        label: handler.company_name
                                                                    }))}
                                                                    onChange={(selected) => {
                                                                        const updatedData = { ...formData, received_by_id: selected.value, received_by: selected.label };
                                                                        setFormData(updatedData);
                                                                        setSelectedReceivedBy(selected);
                                                                        setUpdatedData(updatedData);
                                                                    }}
                                                                    placeholder="Received By"
                                                                    className='autoslct'
                                                                    name="received_by"
                                                                    // value={receivedBy.find(option => option.value === (selectedOriginHandler ? selectedOriginHandler.value : ''))}
                                                                    value={selectedReceivedBy ? { value: selectedReceivedBy.value, label: selectedReceivedBy.label } : null}
                                                                    isDisabled={!receivedBy.length}
                                                                />
                                                                {/* <Form.Control
                                                            type="text"
                                                            placeholder=""
                                                            name='received_by'
                                                            maxLength={9}
                                                            onChange={handleFoundChange}
                                                            value={formData?.received_by || ''}
                                                        /> */}
                                                            </>
                                                            : <>{foundData?.trucking_info?.movement_history[0]?.received_by}</>
                                                        }
                                                    </span>
                                                </li>
                                            </>
                                            : (foundData.trucking_info?.status === 'Repair' ?
                                                <>
                                                    <li>
                                                        <span>Repair Name</span>
                                                        <span className='d-flex'>
                                                            <label>:</label>
                                                            {isedit ?
                                                                <>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder=""
                                                                        name='operation_date'
                                                                        maxLength={9}
                                                                        onChange={handleFoundChange}
                                                                        value={formData?.operation_date || ''}
                                                                    />
                                                                </>
                                                                : <>{foundData?.trucking_info?.movement_history[0]?.operation_date}</>
                                                            }
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span>Repair Station</span>
                                                        <span className='d-flex'>
                                                            <label>:</label>
                                                            {isedit ?
                                                                <>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder=""
                                                                        name='repair_station'
                                                                        maxLength={9}
                                                                        onChange={handleFoundChange}
                                                                        value={formData?.repair_station || ''}
                                                                    />
                                                                </>
                                                                : <>{foundData?.trucking_info?.movement_history[0]?.repair_station}</>
                                                            }
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span>Repair In</span>
                                                        <span className='d-flex'>
                                                            <label>:</label>
                                                            {isedit ?
                                                                <>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder=""
                                                                        name='repair_in'
                                                                        maxLength={9}
                                                                        onChange={handleFoundChange}
                                                                        value={formData?.repair_in || ''}
                                                                    />
                                                                </>
                                                                : <>{foundData?.trucking_info?.movement_history[0]?.repair_in}</>
                                                            }
                                                        </span>
                                                    </li>
                                                </>
                                                : ''
                                            )
                                        )
                                    }
                                </ul>
                            </div>
                        </Col>
                        <Col sm='6'>
                            <div className='missing_info mb-0 h-100'>

                                <h4 className='position-relative'>Mismatch Information</h4>
                                <p>Overview of ULD Mismatch</p>

                                <ul className='rauld_found'>
                                    <li>
                                        <span> ULD Number </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.uld_number} </span>
                                    </li>

                                    <li>
                                        <span> Message Type </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.message_type} </span>
                                    </li>

                                    <li>
                                        <span> Mismatch Type </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.mismatch_type} </span>
                                    </li>

                                    <li>
                                        <span> System Location </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.system_location} </span>
                                    </li>

                                    <li>
                                        <span> Message Location </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.message_location} </span>
                                    </li>

                                    <li>
                                        <span> Updated On </span>
                                        <span className='d-flex'> <label>:</label> {foundData?.movement_date} </span>
                                    </li>
                                </ul>

                                {/* <div className='d-flex'>
                                    <span className='w-50 fw-bold'>ULD Number :</span>
                                    <span className='w-50'>{foundData?.uld_number}</span>
                                </div>
                                <div className='d-flex'>
                                    <span className='w-50 fw-bold'>Message Type :</span>
                                    <span className='w-50'>{foundData?.message_type}</span>
                                </div>
                                <div className='d-flex'>
                                    <span className='w-50 fw-bold'>Mismatch Type :</span>
                                    <span className='w-50'>{foundData?.mismatch_type}</span>
                                </div>
                                <div className='d-flex'>
                                    <span className='w-50 fw-bold'>System Location :</span>
                                    <span className='w-50'>{foundData?.system_location}</span>
                                </div>
                                <div className='d-flex'>
                                    <span className='w-50 fw-bold'>Message Location :</span>
                                    <span className='w-50'>{foundData?.message_location}</span>
                                </div>
                                <div className='d-flex'>
                                    <span className='w-50 fw-bold'>Movement Date :</span>
                                    <span className='w-50'>{foundData?.movement_date}</span>
                                </div> */}
                                <hr />
                                <p
                                    className="review_cs"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            foundData?.message_type === 'SCM'
                                                ? `On ${foundData?.movement_date}, a mismatch was detected for ULD ${foundData?.uld_number}. The system records indicate that the ULD should be at ${foundData?.system_location}, but it is not reported in the <b>${foundData?.message_type}</b>.`
                                                : `On ${foundData?.movement_date}, a mismatch was detected for ULD ${foundData?.uld_number}. The system records indicate that the ULD should be at ${foundData?.system_location}, but based on the UCM Out, it's departing from <b>${foundData?.message_location}</b>.`,
                                    }}
                                ></p>

                            </div>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer className='w-50 mx-auto'>
                    <Button variant="primary" onClick={updateReview} disabled={isSaving} className='position-relative'>
                        {isSaving ? <> Update Status <div className='mvt loader-container' style={{ height: 41 + 'px' }}><span className='mvt loader' style={{ top: 3 + 'px', left: 45 + '%' }}></span></div></> : 'Update Status'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default MVTMismatch